import React, { Component } from 'react';
import FormModal from 'components/shared/modal/FormModal';
import { connect } from 'react-redux';
import {
  getProposals,
  getQuotes,
} from 'selectors/admin/work-orders/details/details';
import { showEditProposalModal } from 'actions/admin/work-orders/details/proposal';
import {
  getSelectedProposalId,
  getShowSuccessMessage,
} from 'selectors/admin/work-orders/details/proposal-approval';
import {
  closeDeclineProposalModal,
  declineProposalRequest,
  showDeclineProposalModal,
} from 'actions/admin/work-orders/details/decline-proposal';
import {
  approveProposalRequest,
  closeProposalApprovalModal,
  closeSuccessModal,
} from 'actions/admin/work-orders/details/proposal-approval';
import numeral from 'numeral';
import './ProposalApprovalModal.css';
import MessageModal from 'components/shared/modal/MessageModal';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import {
  loadQualificationsSuccess,
  setSelectedQualificationsById,
} from 'actions/admin/work-orders/details/qualifications';
import { ProposalStatus } from 'domain/proposal-status-enum';
import { getCurrentUser } from 'selectors/authentication';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
import { PermissionsUtil } from 'services/utils/permissions-util';
import { loadWorkOrderRequest } from 'actions/admin/work-orders/details/details';
import { toUpperFirstLetter } from 'services/utils/text-util';
import TasksReviewTable from 'components/admin/work-orders/details/proposals/TasksReviewTable';
import CostsDatesProposal from 'components/admin/work-orders/details/proposals/CostsDatesProposal';
import Button from 'components/shared/button/Button';
import {
  closePdfViewer,
  printProposal,
  setShowEmailModal,
  withDrawProposalRequest,
  depositSelectedChange,
  depositCostChange,
} from 'actions/admin/work-orders/details/proposal';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import printSvg from 'images/print.svg';
import mailSvg from 'images/mail.svg';
import {
  getPdf,
  getShowPdfViewer,
  getUsers,
} from 'selectors/admin/work-orders/details/proposal';
import ProposalEmailModal from 'components/admin/work-orders/details/proposals/ProposalEmailModal';
import DepositContainer from 'components/admin/work-orders/details/deposit/DepositContainer';
import QualificationsContainer from 'components/admin/work-orders/details/qualifications/QualificationsContainer';
import moment from 'moment';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import DeclineModal from 'components/shared/modal/DeclineModal';
import { getDeclineProposalShow } from 'selectors/admin/work-orders/details/decline-proposal';

/**
 * This component is used in DetailsQuotes, and show if a proposal is selected
 */
export class ProposalApprovalModal extends Component {
  constructor(props) {
    super(props);

    let quotes = {};
    this.selectedProposal = props.proposals.find(
      (element) => element.id === props.selectedProposalId
    );
    this.selectedProposal.proposal_quotes.forEach((proposalQuote) => {
      const quoteId = proposalQuote.quote_id;
      let quoteTotal;
      const quote = props.quotes.find((element) => element.id === quoteId);
      if (quote !== undefined) {
        // Update quote estimate and value with proposal values (fee, insurance and markup)
        // DON'T UPDATE STATE OBJECT!!!
        quoteTotal =
          numeral(quote.estimate).value() +
          numeral(quote.value).value() +
          numeral(proposalQuote.fee).value() +
          numeral(proposalQuote.insurance).value() +
          numeral(proposalQuote.markup).value();
        quotes[quote.id] = { quote, total: quoteTotal, selected: true };
      }
    });

    this.state = {
      showWithdrawConfirmation: false,
      quotes: quotes,
    };
  }

  componentDidMount() {
    if (
      this.selectedProposal.qualifications.length > 0 &&
      this.selectedProposal.proposal_qualifications.length > 0
    ) {
      const selectedQualificationsById = this.selectedProposal.proposal_qualifications.reduce(
        (accumulator, currentValue) => {
          accumulator[currentValue.qualification_id] = {
            id: currentValue.qualification_id,
            // value=0 because we only need the label
            option:
              currentValue.option !== null
                ? { value: 0, label: currentValue.option }
                : null,
          };
          return accumulator;
        },
        {}
      );
      this.props.dispatch(
        setSelectedQualificationsById(selectedQualificationsById)
      );
      this.props.dispatch(
        loadQualificationsSuccess(this.selectedProposal.qualifications)
      );
    } else {
      this.props.dispatch(setSelectedQualificationsById({}));
      this.props.dispatch(loadQualificationsSuccess([]));
    }

    const deposit = this.selectedProposal.deposit;

    if (deposit !== undefined && deposit !== null) {
      this.props.dispatch(depositSelectedChange(true));
      this.props.dispatch(depositCostChange(deposit.cost));
    } else {
      this.props.dispatch(depositCostChange(null));
    }
  }

  handleApprove = () => {
    this.props.dispatch(
      approveProposalRequest(
        this.props.selectedProposalId,
        Object.values(this.state.quotes)
          .filter((element) => element.selected)
          .map((element) => element.quote.id)
      )
    );
  };

  handleDecline = () => {
    this.props.dispatch(showDeclineProposalModal());
  };

  handleDeclineSubmit = (values) => {
    if (values.sure === 'yes') {
      this.props.dispatch(
        declineProposalRequest(
          this.props.currentWorkOrder.id,
          this.props.selectedProposalId,
          values.password,
          values.reason,
          this.props.additionalInfo
        )
      );
    } else {
      this.props.dispatch(closeDeclineProposalModal());
    }
  };

  handleClose = (event) => {
    event.preventDefault();
    this.props.dispatch(closeProposalApprovalModal());
  };

  handleEdit = (event) => {
    event.preventDefault();
    this.props.dispatch(closeProposalApprovalModal());

    const selectedProposal = this.props.proposals.find(
      (element) => element.id === this.props.selectedProposalId
    );
    this.props.dispatch(showEditProposalModal(selectedProposal));
  };

  handleQuoteCheck = (quoteId) => {
    this.setState({
      quotes: {
        ...this.state.quotes,
        [quoteId]: {
          ...this.state.quotes[quoteId],
          selected: !this.state.quotes[quoteId].selected,
        },
      },
    });
  };

  handleCloseSuccessModal = () => {
    let userIsAdmin =
      usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
      usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR);
    let userIsContractor = usersUtil.hasType(
      this.props.currentUser,
      TYPES.CONTRACTOR
    );
    let contractorUserCanSeeMoney = PermissionsUtil.contractorUserCanSeeMoney(
      this.props.currentUser
    );

    this.props.dispatch(closeSuccessModal());
    this.props.dispatch(closeProposalApprovalModal());
    this.props.dispatch(
      loadWorkOrderRequest(
        this.props.currentWorkOrder.id,
        userIsAdmin,
        userIsContractor,
        contractorUserCanSeeMoney
      )
    );
  };

  static getWorkOrderName(workOrder) {
    return workOrder.name !== null ? `: ${workOrder.name}` : '';
  }

  handleProposalPrint = () => {
    this.props.dispatch(printProposal(this.selectedProposal.id));
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(closePdfViewer());
  };

  handleProposalEmail = () => {
    this.props.dispatch(setShowEmailModal(true));
  };

  handleWithdraw = () => {
    this.setState({ showWithdrawConfirmation: true });
  };

  handleWithdrawConfirmation = (response) => {
    this.setState({ showWithdrawConfirmation: false });
    if (response) {
      this.props.dispatch(withDrawProposalRequest(this.selectedProposal.id));
    }
  };

  getMaterialLeadTime(mDays) {
    if (mDays) {
      return `${numeral(mDays).value()} ${mDays > 1 ? 'days' : 'day'}`;
    }

    return 'N/A';
  }

  render() {
    const canSelectTask =
      ProposalStatus.WAITING.equals(this.selectedProposal.status) &&
      usersUtil.hasType(this.props.currentUser, TYPES.CLIENT);
    const values = [];
    Object.values(this.state.quotes)
      .sort((e1, e2) => {
        return e1.quote && e2.quote
          ? e1.quote.task.number - e2.quote.task.number
          : -1;
      })
      .forEach((element) => {
        if (element.quote !== undefined) {
          let proposal_quote = this.selectedProposal.proposal_quotes.find(
            (pq) => pq.quote_id === element.quote.id
          );
          let value = {
            id: element.quote.id,
            number: element.quote.task.number,
            details:
              element.quote.task.name !== null
                ? element.quote.task.name
                : element.quote.task.trade.label,
            materialLeadTime: this.getMaterialLeadTime(
              element.quote.material_lead_days
            ),
            cost: numeral(element.total).value(),
            markup: numeral(proposal_quote.markup).value(),
            fee: numeral(proposal_quote.fee).value(),
            insurance: numeral(proposal_quote.insurance).value(),
            breakdownItems: proposal_quote.breakdown_items,
          };

          // If proposal is waiting for approval (and user is not client), show checks to select tasks
          if (canSelectTask) {
            value['selected'] = element.selected;
          }

          values.push(value);
        }
      });

    // Only take into account selected quotes for total
    const total = Object.values(this.state.quotes).reduce(
      (accumulator, currentValue) => {
        if (currentValue.selected) {
          return accumulator + currentValue.total;
        } else {
          return accumulator;
        }
      },
      0
    );

    let successMessage =
      'Thank you. The Proposal approval was submitted to Spackle';
    if (
      this.props.currentWorkOrder.client.po_required &&
      !this.props.currentWorkOrder.client.global_po_required
    ) {
      successMessage += ', please upload the Purchase Order document.';
    } else {
      successMessage += '.';
    }

    let titlePostfix;
    if (usersUtil.hasType(this.props.currentUser, TYPES.CLIENT)) {
      titlePostfix = moment(this.selectedProposal.created_at).format('LL');
    } else {
      let reason = '';
      if (this.selectedProposal.rejected_reason_1) {
        let reason1 = this.selectedProposal.rejected_reason_1;
        let reason2 = this.selectedProposal.rejected_reason_2;
        reason = ` (${reason1}` + (reason2 ? `: ${reason2})` : ')');
      }

      titlePostfix = toUpperFirstLetter(this.selectedProposal.status) + reason;
    }
    const title = `Proposal (WO #${
      this.props.currentWorkOrder.number
    } ${ProposalApprovalModal.getWorkOrderName(
      this.props.currentWorkOrder
    )}) - ${titlePostfix}`;

    return (
      <React.Fragment>
        <FormModal
          className="proposal-modal proposal-approval-modal"
          show={this.props.selectedProposalId !== null}
          title={title}
          subTitle={
            <div className="h2">
              Spackle is pleased to submit proposal #
              {this.selectedProposal.number} for:
            </div>
          }
          onClose={this.handleClose}
        >
          <div className="proposal-approval-container">
            <TasksReviewTable
              showSelection={canSelectTask}
              values={values}
              onSelection={this.handleQuoteCheck}
            />

            <div className="costs-dates-container">
              <div className="buttons">
                <Button
                  className="button-white"
                  icon={mailSvg}
                  label="Email"
                  onClick={this.handleProposalEmail}
                />
                <Button
                  className="button-white print-button"
                  icon={printSvg}
                  label="Print"
                  onClick={this.handleProposalPrint}
                />
              </div>

              <CostsDatesProposal
                completionDate={{
                  value: this.selectedProposal.completion_date,
                }}
                startDate={this.selectedProposal.start_date}
                total={total}
              />
            </div>

            <DepositContainer readOnly={true} />

            <QualificationsContainer readOnly={true} />

            <div className="proposal-days-sign">
              <div className="body-bold">Proposal is good for 30 days</div>
              <div className="small-regular">4130 Cahuenga Blvd, Suite 206</div>
              <div className="small-regular">Los Angeles, CA 91602</div>
              <div className="small-regular">Phone: (310) 848-3078</div>
            </div>

            {ProposalStatus.WAITING.equals(this.selectedProposal.status) &&
              usersUtil.hasType(this.props.currentUser, TYPES.CLIENT) && (
                <div className="buttons-container">
                  <Button
                    className="button-orange"
                    disabled={
                      Object.values(this.state.quotes).filter(
                        (element) => element.selected
                      ).length === 0
                    }
                    label="Approve"
                    onClick={this.handleApprove}
                  />
                </div>
              )}

            {ProposalStatus.WAITING.equals(this.selectedProposal.status) &&
              (usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
                usersUtil.hasType(
                  this.props.currentUser,
                  TYPES.GENERAL_CONTRACTOR
                )) && (
                <div className="buttons-container">
                  <Button
                    className="button-white"
                    label="Decline"
                    onClick={this.handleDecline}
                  />
                  <Button
                    className="button-gray"
                    label="Withdraw"
                    onClick={this.handleWithdraw}
                  />
                  <Button
                    className="button-orange"
                    disabled={
                      Object.values(this.state.quotes).filter(
                        (element) => element.selected
                      ).length === 0
                    }
                    label="Approve"
                    onClick={this.handleApprove}
                  />
                </div>
              )}

            {ProposalStatus.APPROVED.equals(this.selectedProposal.status) &&
              (usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
                usersUtil.hasType(
                  this.props.currentUser,
                  TYPES.GENERAL_CONTRACTOR
                )) && (
                <div className="buttons-container">
                  <Button
                    className="button-orange"
                    label="Edit"
                    onClick={this.handleEdit}
                  />
                </div>
              )}

            {/*<DeclineProposalModal />*/}
            <DeclineModal
              show={this.props.showDeclineModal}
              onSubmit={this.handleDeclineSubmit}
            />
          </div>
        </FormModal>

        <MessageModal
          show={this.props.showSuccessMessage}
          message={<div>{successMessage}</div>}
          onHide={this.handleCloseSuccessModal}
        />

        <PdfViewer
          content={{
            source: this.props.pdf,
            type: 'blob',
          }}
          show={this.props.showPdfViewer}
          onClose={this.handlePdfViewerClose}
        />

        <ProposalEmailModal />

        <ConfirmationModal
          show={this.state.showWithdrawConfirmation}
          message="Are you sure"
          onHide={this.handleWithdrawConfirmation}
        />
      </React.Fragment>
    );
  }

  static renderTotal(label, value) {
    return (
      <table>
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td />
            <td>{label}</td>
            <td>{value}</td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    pdf: getPdf(state),
    proposals: getProposals(state),
    quotes: getQuotes(state),
    selectedProposalId: getSelectedProposalId(state),
    showDeclineModal: getDeclineProposalShow(state),
    showPdfViewer: getShowPdfViewer(state),
    showSuccessMessage: getShowSuccessMessage(state),
    users: getUsers(state),
  };
})(ProposalApprovalModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/ProposalApprovalModal.js